import {
  Rocket,
  Network,
  FileText,
  HelpCircle,
  Lightbulb,
  Gift,
  Sparkles,
  Download,
} from "lucide-react";

const WebinarBenefits = () => {
  const benefitsData = [
    {
      icon: <Rocket className="w-5 h-5 text-indigo-400" />,
      title: "Career Roadmap to PM, VC, BizOps & More",
      description: "Strategic growth plan after Founder's Office roles.",
    },
    {
      icon: <Network className="w-5 h-5 text-blue-500" />,
      title: "LinkedIn Strategies to Get Noticed by Founders",
      description: `Real hooks and positioning — not "open to work" posts`,
    },
    {
      icon: <FileText className="w-5 h-5 text-purple-400" />,
      title: " Instant PDF Pack: Founder's Office Kit",
      description:
        "Resume + cold email templates, case questions, tools list & more.",
    },
    {
      icon: <HelpCircle className="w-5 h-5 text-emerald-400" />,
      title: "Live Q&A With Yuganksha",
      description:
        "Ask her anything — from her Souled Store experience to her ZS journey.",
    },
  ];

  return (
    <div className="bg-black py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-indigo-500/10 border border-indigo-500/30 backdrop-blur-sm">
            <div className="w-4 h-4 bg-indigo-400 rounded-full animate-pulse" />
            <span className="text-sm font-semibold text-indigo-400 tracking-wide uppercase">
              Additional Benefits
            </span>
          </div>
        </div>

        <div className="space-y-6">
          <h2 className="text-center text-3xl sm:text-4xl font-bold mb-4">
            <span className="bg-gradient-to-r from-white to-gray-500 bg-clip-text text-transparent">
              More Than Just Gyaan —
            </span>
            <br />
            <span className="bg-gradient-to-r from-white to-gray-500 bg-clip-text text-transparent">
              Real Assets You'll Use
            </span>
          </h2>

          <p className="flex justify-center text-base text-gray-400 max-w-2xl  mx-auto tracking-wide">
            Get tangible value even before attending
          </p>
          {/* Benefits Grid - All Same Size */}
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {benefitsData.map((benefit, index) => (
              <div
                key={index}
                className="group relative bg-black border border-indigo-500/30 rounded-lg p-6 h-full
                           md:hover:border-indigo-400 transition-all duration-300 
                           md:hover:bg-gradient-to-br md:hover:from-indigo-900/20 md:hover:to-blue-900/20
                           md:hover:scale-[1.02] md:hover:-translate-y-1"
              >
                <div
                  className="absolute -inset-0.5 bg-gradient-to-r from-indigo-500 to-blue-500 
                                rounded-lg blur opacity-0 md:group-hover:opacity-30 
                                transition duration-300"
                />

                <div className="relative flex items-start gap-4 h-full">
                  <div className="p-3 rounded-lg bg-indigo-500/10 md:group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                    {benefit.icon}
                  </div>

                  <div className="flex-1 flex flex-col">
                    <h3 className="text-base text-left font-bold mb-2 text-white md:group-hover:text-indigo-300 transition-colors">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-400 text-left text-sm md:group-hover:text-gray-200 transition-colors flex-1">
                      {benefit.description}
                    </p>
                  </div>
                </div>

                {/* Corner accent - Desktop only */}
                <div className="absolute top-2 right-2 w-2 h-2 bg-indigo-400 rounded-full opacity-0 md:group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            ))}
          </div>

          {/* Section Divider */}
          <div className="relative my-12">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full">
                <div className="h-px bg-gradient-to-r from-transparent via-gray-500/20 to-transparent"></div>
              </div>
            </div>
            <div className="relative flex justify-center">
              <div className="px-4 bg-black">
                <div className="w-2 h-2 bg-gray-500/30 rounded-full"></div>
              </div>
            </div>
          </div>

          {/* Enhanced Bonus Card - Desktop Hover Only */}
          <div className="relative mt-8">
            {/* Floating particles - Desktop hover only */}
            <div className="absolute -inset-2 sm:-inset-4 opacity-30 hidden md:block">
              <div className="absolute top-2 left-1/4 w-1 h-1 bg-slate-400 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div
                className="absolute top-1/4 right-1/4 w-1 h-1 bg-slate-300 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ animationDelay: "0.5s" }}
              />
              <div
                className="absolute bottom-1/4 left-1/3 w-1 h-1 bg-gray-400 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ animationDelay: "1s" }}
              />
            </div>

            {/* Main bonus card */}
            <div
              className="group relative bg-gradient-to-r from-blue-900/40 via-slate-800/50 to-blue-800/40 rounded-xl p-4 sm:p-6
                     backdrop-blur-xl border border-blue-600/30
                     md:hover:border-blue-500/50 transition-all duration-500
                     md:hover:shadow-lg md:hover:shadow-blue-500/20
                     transform md:hover:scale-105"
            >
              {/* Background glow on desktop hover only */}
              <div className="absolute -inset-0.5 sm:-inset-1 bg-gradient-to-r from-blue-500/20 via-blue-400/25 to-blue-600/20 rounded-xl blur opacity-0 md:group-hover:opacity-40 transition-all duration-500" />
              {/* Content Layout - Mobile: Vertical, Desktop: Horizontal */}
              <div className="relative flex flex-col sm:flex-row items-center gap-4 sm:gap-4">
                {/* Icon - Different for mobile vs desktop */}
                <div className="relative flex-shrink-0">
                  <div
                    className="relative p-4 sm:p-3 bg-blue-600/30 rounded-xl text-blue-300
                           md:group-hover:scale-110 md:group-hover:rotate-12 transition-all duration-500"
                  >
                    {/* Mobile: Gift icon, Desktop: Lightbulb icon */}
                    <div className="block sm:hidden">
                      <Gift className="w-8 h-8" />
                    </div>
                    <div className="hidden sm:block">
                      <Gift className="w-6 h-6" />
                    </div>
                    {/* Sparkle effect on desktop hover only */}
                    <div className="absolute -top-1 -right-1 opacity-0 md:group-hover:opacity-100 transition-opacity duration-300 hidden md:block">
                      <Sparkles className="w-3 h-3 text-yellow-400 animate-pulse" />
                    </div>
                  </div>
                  {/* Desktop: Glow ring on hover only */}
                  <div className="absolute -inset-2 bg-gradient-to-r from-blue-500/15 to-blue-400/15 rounded-full blur-md opacity-0 md:group-hover:opacity-60 transition-all duration-500 hidden md:block" />
                </div>
                <div className="flex-1 text-center sm:text-left">
                  {/* Header - Mobile: No left icon, Desktop: With left icon */}
                  <div className="flex items-center justify-center sm:justify-start gap-2 mb-3 sm:mb-2">
                    {/* Desktop only: Small gift icon */}
                    <h3
                      className="font-bold text-xl sm:text-lg text-blue-200
                            md:group-hover:text-white transition-colors duration-300"
                    >
                      Bonus Resources Worth ₹200
                    </h3>
                  </div>
                  <p
                    className="text-blue-300 md:group-hover:text-blue-200 text-base sm:text-sm
                        transition-colors duration-300 mb-4 sm:mb-3"
                  >
                    Instantly emailed after booking
                  </p>
                  {/* Download CTA Section */}
                  <div className="flex items-center justify-center sm:justify-start gap-2 mb-3">
                    <div className="flex items-center gap-2 px-3 py-1.5 bg-blue-700/50 rounded-full border border-blue-600/40 md:group-hover:bg-blue-600/60 md:group-hover:border-blue-500/60 transition-all duration-300">
                      <Download className="w-3 h-3 text-blue-300 md:group-hover:text-white transition-colors duration-300" />
                      <span className="text-xs font-semibold text-blue-300 md:group-hover:text-white transition-colors duration-300">
                        Download Upon Register
                      </span>
                    </div>
                  </div>
                  <div className="hidden sm:flex items-center gap-2">
                    <div className="flex-1 h-1 bg-blue-800 rounded-full overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-blue-500 to-blue-400 rounded-full w-0 md:group-hover:w-full transition-all duration-1000 ease-out" />
                    </div>
                    <span className="text-xs text-blue-300 font-semibold opacity-0 md:group-hover:opacity-100 transition-opacity duration-500 whitespace-nowrap">
                      Instant Delivery!
                    </span>
                  </div>
                  {/* Different text for mobile vs desktop */}
                  <div className="mt-4 sm:mt-2 text-center sm:text-left">
                    {/* Mobile text */}
                    <span className="block sm:hidden text-amber-400 text-sm font-semibold">
                      🎁 Premium templates, case questions, tools lists and more
                    </span>
                    {/* Desktop text */}
                    <span className="hidden sm:block text-amber-400 text-sm font-semibold opacity-70 md:group-hover:opacity-100 transition-opacity duration-300">
                      🎁 Premium templates, case questions, tools lists and more
                    </span>
                  </div>
                </div>
              </div>
              {/* Corner indicator - Desktop hover only */}
              <div className="absolute top-2 right-2 hidden md:block">
                <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-blue-400 rounded-full opacity-30 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebinarBenefits;
